<template>
  <div class="user-base-info">
    <div class="user-base-info-left">
      <div class='account-item' v-if='tgoUserInfo.name'>
        <span class='account-item-key'>姓名：</span>
        <span class='account-item-value'>{{tgoUserInfo.name}}</span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.gender'>
        <span class='account-item-key'>性别：</span>
        <span class='account-item-value'>{{gender[tgoUserInfo.gender]}}</span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.birthday'>
        <span class='account-item-key'>生日：</span>
        <span class='account-item-value'>{{birthday}}</span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.phone'>
        <span class='account-item-key'>手机：</span>
        <span class='account-item-value'>{{`${tgoUserInfo.area_code}${tgoUserInfo.phone}`}}</span>
      </div>
      <div class='account-item' v-if="tgoUserInfo.email && tgoUserInfo.email.trim()">
        <span class='account-item-key'>E-mail：</span>
        <span class='account-item-value'>{{tgoUserInfo.email}}</span>
      </div>
      <div class='account-item' v-if='tgoUserInfo.wechat'>
        <span class='account-item-key'>微信号：</span>
        <span class='account-item-value'>{{tgoUserInfo.wechat}}</span>
      </div>
      <!-- <div class='account-item' v-if='tgoUserInfo.city'>
        <span class='account-item-key'>所在城市：</span>
        <span class='account-item-value'>
          <span v-if="tgoUserInfo.country">{{country[tgoUserInfo.country]}}</span>
          <span v-if="province&&Number(tgoUserInfo.country)!==2">{{province.name}}</span>
          <span v-if="city">{{city.name}}</span>
        </span>
      </div> -->
      <div class='account-item' v-if="tags.length">
        <span class='account-item-key'>个人专注领域：</span>
        <span class='account-item-value' v-for="(tag, idx) in tags" :key="idx">{{`${tag.name}${idx===tags.length-1?'':'、'}`}}</span>
      </div>
      <!-- <div class='account-item' v-if='tgoUserInfo.branch'>
        <span class='account-item-key'>期望加入的分会：</span>
        <span class='account-item-value'>{{tgoUserInfo.branch.name}}</span>
      </div> -->
      <div class='account-item' v-if="size.length">
        <span class='account-item-key'>穿衣尺码：</span>
        <span class='account-item-value'>{{size[0].name}}</span>
      </div>
      <!-- 上传头像 -->
      <!-- <div class="account-item account-avatar" v-if="Number(statusInfo.status)===8">
        <tgo-avatar :statusInfo="statusInfo" use="1"></tgo-avatar>
        <tgo-avatar :statusInfo="statusInfo" use="2"></tgo-avatar>
      </div> -->
    </div>
    <div class="user-base-info-right">
      <div class="modify-btn" @click="modifyFn">修改</div>
    </div>
  </div>
</template>
<script>
// import service from '@/service'
// import tgoAvatar from './upload-avatar'
// import areaData from '@/config/areaData.js'
import staticData from './modify/info-config'
import moment from 'moment'

export default {
  data () {
    return {
      // areaData,
      staticData,
      gender: {
        'M': '先生',
        'F': '女士'
      },
      country: {
        '1': '中国',
        '2': '美国'
      }
      // branch: '' // 期望加入的分会
    }
  },
  props: ['tgoUserInfo', 'statusInfo'],
  components: {
    // tgoAvatar
  },
  created () {},
  methods: {
    modifyFn () {
      this.$emit('setState')
      this.$emit('notifyInfos')
    }
  },
  computed: {
    birthday () {
      if (this.tgoUserInfo.birthday) {
        return moment.unix(Number(this.tgoUserInfo.birthday)).format('YYYY年MM月DD日')
      } else {
        return ''
      }
    },
    // province () {
    //   if (Number(this.tgoUserInfo.province) === 0) {
    //     return this.areaData['86'].filter(item => item.cid === Number(this.tgoUserInfo.country))[0] || [{'name': '', 'id': ''}]
    //   } else {
    //     return this.areaData['86'].filter(item => item.cid === Number(this.tgoUserInfo.country) && item.id === Number(this.tgoUserInfo.province))[0] || [{'name': '', 'id': ''}]
    //   }
    // },
    // city () {
    //   if (this.areaData[this.province.id]) {
    //     return this.areaData[this.province.id].childs.filter(item => item.id === Number(this.tgoUserInfo.city))[0] || [{'name': ''}]
    //   }
    // },
    size () {
      if (this.tgoUserInfo.size) {
        return this.staticData['size']['labels'].filter(item => item.value === this.tgoUserInfo.size) || []
      } else {
        return []
      }
    },
    tags () {
      return (this.tgoUserInfo.focus_areas_tags && this.tgoUserInfo.focus_areas_tags['1']) || []
    }
  },
  watch: {}
}
</script>
<style lang='sass'>
@import '../../../../style/bulma/app.sass'

.user-base-info
  display: flex
  justify-content: space-between
  .user-base-info-left
    width: 80%
    .account-item
      padding: 8px 0
      display: flex
      flex-wrap: wrap
      .account-item-key
        word-break: keep-all
      .account-item-value
        word-break: break-word
      &.account-avatar
        display: flex
      .account-item-key
        color: #353535
      .account-item-value
        color: #888
  .user-base-info-right
    width: 15%
    display: flex
    justify-content: flex-end
    align-items: baseline
    .modify-btn
      padding: 5px 30px
      border: 1px solid $primary3
      color: $primary3
      border-radius: 5px
      cursor: pointer
      word-break: keep-all

</style>
